import {Component, HostBinding, OnDestroy, OnInit, ViewChild} from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';

import { Subscription } from 'rxjs';
import { ReportPageConstant } from 'src/app/constants/reportPage.constants';
import { ReportPageInterface } from 'src/app/interface';
import { Report, FieldValue, Location, FieldValueReset, IncomeStatement } from 'src/app/model';
import { FooterButtonOption, IncomeStatementType, PageNumbers, RentCalculationTypes } from 'src/app/model/Enums';
import { LocationRentAdjustment } from 'src/app/model/location-rent-adjustment';
import { ReportProvider } from 'src/app/providers';
import { ReportService, ToasterService } from 'src/app/services';
import { radioGroupOption } from '../../../commonModel/common-classes';
import {routeTransition} from '../../../../../animations/route-transition';

@Component({
  selector: 'app-rent-details',
  templateUrl: './rent-details.component.html',
  styleUrls: ['./rent-details.component.scss'],
  animations: [routeTransition],
})
export class RentDetailsComponent implements OnInit, OnDestroy, ReportPageInterface {
  @HostBinding('@routeTransition') routeAnimation = true;
  @ViewChild('rentForm') rentForm: NgForm;

  public currentReport: Report;
  private reportSub: Subscription;
  reportPageConst = ReportPageConstant;

  locationList: Location[] = [];
  rentTypeList: radioGroupOption[] = [];
  rentTypeListFirst: radioGroupOption = null;
  fullOccupationList: radioGroupOption[] = [];

  mostRecentYear: string = '';
  incomeYearList: IncomeStatement[] = [];

  selectedLocation = new Location();
  rentTypesEnum = RentCalculationTypes;

  isShow: boolean = true;

  constructor(public reportService: ReportService,
    private reportProvider: ReportProvider,
    private router: Router,
    private toastr: ToasterService) { }

  ngOnInit(): void {

    // this.rentTypeListFirst = { title: 'I know the square footage of the building', value: RentCalculationTypes.SQUARE_FOOTAGE }

    this.rentTypeList.push({ title: 'I know the square footage of the building', value: RentCalculationTypes.SQUARE_FOOTAGE });
    this.rentTypeList.push({ title: 'I know the square footage of the building and the fair market rental rate per square foot', value: RentCalculationTypes.SQUARE_FOOTAGE_AND_MARKET_RENT });
    this.rentTypeList.push({ title: 'I know the approximate value of the real estate', value: RentCalculationTypes.APPROXIMATE_VALUE });
    this.rentTypeList.push({ title: 'Buyer and Landlord have negotiated a new lease', value: RentCalculationTypes.LEASE_NEGOTIATED });

    this.fullOccupationList.push({ title: 'Yes', value: true });
    this.fullOccupationList.push({ title: 'No', value: false });

    this.reportSub = this.reportService.report$.subscribe(currentReport => {
      this.currentReport = currentReport;
      if (this.currentReport?.LATEST?.LOCATION_LIST?.length) {

        this.currentReport.LATEST.LOCATION_LIST.sort((a, b) => Number(a.ORDER) - Number(b.ORDER));

        this.currentReport.LATEST.LOCATION_LIST.forEach(element => {
          if (element.IS_OWNED || (!element.IS_OWNED && element.IS_RENT_INCREASE)) {
            element.isSqfVisivle = false;
            this.locationList.push(element);
          }
        });

        setTimeout(() => {
          this.locationList.sort((a, b) => Number(a.ORDER) - Number(b.ORDER));
          if (this.locationList.length)
            this.selectLocation(this.locationList[0]);
        }, 1);

      }
      if (this.currentReport?.LATEST?.INCOME_STATEMENT?.length) {
        this.mostRecentYear = new Date(this.currentReport.LATEST.RECENT_FINANCIAL_DATE).getFullYear().toString();
        for (let i = 0; i < this.currentReport.LATEST.INCOME_STATEMENT.length; i++) {
          const element = this.currentReport.LATEST.INCOME_STATEMENT[i];
          if (element.IS_TYPE != IncomeStatementType.INTERIM) {
            this.incomeYearList.push(element);
          }
        }
        this.incomeYearList.sort((a, b) => Number(a.YEAR) - Number(b.YEAR));
      }
    });

  }

  ngOnDestroy(): void {
    this.locationList.forEach(element => {
      const locListIndex = this.currentReport.LATEST.LOCATION_LIST.findIndex(el => el.ID == element.ID);
      this.currentReport.LATEST.LOCATION_LIST[locListIndex] = element;
    });
    if (this.reportSub)
      this.reportSub.unsubscribe();
  }

  /**
   * @description for select location
   * @param location selected location object
   */
  selectLocation(location) {
    this.isShow = false;
    this.selectedLocation = location;
    if (this.selectedLocation?.RENT_ADJUSTMENT_YEARLY?.length) {
      this.selectedLocation.RENT_ADJUSTMENT_YEARLY.sort((a, b) => Number(a.INCOME_STATEMENT.YEAR) - Number(b.INCOME_STATEMENT.YEAR));
    }
    if (this.selectedLocation.AUTO_CALCULATED) {
      this.callApiForCheckSQF();
    }
    setTimeout(() => {
      this.isShow = true;
    }, 5);
  }

  /**
   * @description field update API
   * @param fieldName field name which we want to update
   */
  callUpdateAPI(fieldName: string) {
    if (fieldName == 'AUTO_CALCULATED' && this.selectedLocation.AUTO_CALCULATED) {
      setTimeout(() => {
        document.getElementById('autoCalcDiv').focus();
      }, 10);
      setTimeout(() => {
        document.activeElement.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
          inline: 'center'
        });
      }, 20);
      this.callApiForCheckSQF();
    } else {
      if (fieldName == 'PERCENT_OCCUPATION') {
        this.selectedLocation.PERCENT_OCCUPATION = Number(this.selectedLocation.PERCENT_OCCUPATION);
      }
      setTimeout(() => {
        window.scrollBy(0, 200);
      }, 5);
    }
    let objFieldValue = new FieldValue();
    objFieldValue.GROUP = 'LOCATION';
    objFieldValue.FIELD = fieldName;
    objFieldValue.VALUE = this.selectedLocation[fieldName]?.toString() ? this.selectedLocation[fieldName].toString() : null;
    this.reportProvider.updateReportField(this.selectedLocation.ID, objFieldValue).subscribe(res => {
      if (res.success) {
        if (fieldName == 'RENT_EXPENSE_EACH_YEAR' && !this.selectedLocation.RENT_EXPENSE_EACH_YEAR) {
          this.selectedLocation.RENT_ADJUSTMENT_YEARLY = [];
        }
      } else {
        this.toastr.error(res.error.txt);
      }
    }, err => {
      // Error Handling
    });
  }

  /**
   * @description for reset fields
   * @param isAutoCalculation is auto calculation
   */
  resetOtherFields(isAutoCalculation: boolean = false) {
    let objFieldValue = new FieldValueReset();
    objFieldValue.GROUP = 'LOCATION';
    objFieldValue.FIELD_LIST = ['SQUARE_FOOTAGE', 'FAIR_MARKET_SQFT', 'APPROXIMATE_VALUE', 'FULL_OCCUPATION', 'PERCENT_OCCUPATION', 'NEGOTIATED_RENT'];
    if (isAutoCalculation) {
      objFieldValue.FIELD_LIST.push('MARKET_RENT');
      objFieldValue.FIELD_LIST.push('RENT_CALCULATION_TYPE');
    }
    this.reportProvider.resetReportField(this.selectedLocation.ID, objFieldValue).subscribe(res => {
      if (res.success) {
        if (isAutoCalculation) {
          this.selectedLocation.MARKET_RENT = 0;
          this.selectedLocation.RENT_CALCULATION_TYPE = null;
        }
        this.selectedLocation.SQUARE_FOOTAGE = null;
        this.selectedLocation.FAIR_MARKET_SQFT = null;
        this.selectedLocation.APPROXIMATE_VALUE = null;
        this.selectedLocation.FULL_OCCUPATION = null;
        this.selectedLocation.PERCENT_OCCUPATION = null;
        this.selectedLocation.NEGOTIATED_RENT = null;
      } else {
        this.toastr.error(res.error.txt);
      }
    }, err => {
      // Error Handling
    });
  }

  /**
   * @description goto location page
   */
  gotoLocation() {
    this.reportService.updateMaxStage(PageNumbers.RENT_DETAILS);
    this.router.navigateByUrl(`/report/${this.currentReport.ID}/location`);
  }

  callApiForCheckSQF() {
    this.reportProvider.checkSQFQuestion(this.currentReport.LATEST.ID, this.selectedLocation.ID).subscribe(res => {
      if (res.success) {
        this.selectedLocation.isSqfVisivle = res.result;
      } else {
        this.selectedLocation.isSqfVisivle = false;
        this.toastr.error(res.error.txt);
      }
    }, err => {
      // Error Handling
    });
  }

  checkRequiredFields() {
    let flag = true;
    if (this.currentReport && this.currentReport.LATEST) {

      if (!this.locationList.length)
        return false;

      this.locationList.forEach(el => {
        if (flag) {
          if (el.MARKET_RENT == null || el.MARKET_RENT == undefined) {
            flag = false;
          }

          if (flag && el.AUTO_CALCULATED) {
            if (!el.RENT_CALCULATION_TYPE) {
              flag = false;
            } else {
              if (((el.RENT_CALCULATION_TYPE == RentCalculationTypes.SQUARE_FOOTAGE && el.ZIP && el.isSqfVisivle) || el.RENT_CALCULATION_TYPE == RentCalculationTypes.SQUARE_FOOTAGE_AND_MARKET_RENT) && !el.SQUARE_FOOTAGE) {
                flag = false;
              } else if (el.RENT_CALCULATION_TYPE == RentCalculationTypes.SQUARE_FOOTAGE_AND_MARKET_RENT && !el.FAIR_MARKET_SQFT) {
                flag = false;
              } else if (el.RENT_CALCULATION_TYPE == RentCalculationTypes.APPROXIMATE_VALUE && (!el.APPROXIMATE_VALUE || el.FULL_OCCUPATION == null || (el.FULL_OCCUPATION == false && !el.PERCENT_OCCUPATION))) {
                flag = false;
              } else if (el.RENT_CALCULATION_TYPE == RentCalculationTypes.LEASE_NEGOTIATED && !el.NEGOTIATED_RENT) {
                flag = false;
              }
            }
          }

          if (flag && ((el.IS_OWNED && !el.IS_OWNED_ON_BS) || (!el.IS_OWNED && el.IS_RENT_INCREASE))) {
            if (!el.RENT_EXPENSE_EACH_YEAR) {
              if (el.RENT_EXPENSE == null || el.RENT_EXPENSE == undefined) {
                flag = false;
              }
            } else {
              el.RENT_ADJUSTMENT_YEARLY.forEach(x => {
                if (flag && x.INCOME_STATEMENT.FINANCIAL_TYPE != 'NOT_AVAILABLE') {
                  if (x.VALUE == null || x.VALUE == undefined) {
                    flag = false;
                  }
                }
              });
            }
          }

        }
      });
    }
    return flag;
  }

  callUpdateRentAdjustmentYearlyAPI(ray: LocationRentAdjustment) {
    let objFieldValue = new FieldValue();
    objFieldValue.GROUP = 'RENT_ADJUSTMENT_YEARLY';
    objFieldValue.FIELD = 'VALUE';
    objFieldValue.VALUE = ray.VALUE;
    this.reportProvider.updateReportField(ray.ID, objFieldValue).subscribe(res => {
      if (!res.success) {
        this.toastr.error(res.error.txt);
      }
    }, err => {
      // Error Handling
    });
  }

  /**
   * @description function call at the time of footer button click, for switch route or location
   */
  switchNextLocation() {
    const currentLocationIndex = this.locationList.findIndex(loc => loc.ID == this.selectedLocation.ID);
    if (currentLocationIndex === this.locationList.length - 1) {
      if (this.checkRequiredFields()) {
        this.reportService.updateMaxStage(PageNumbers.RENT_DETAILS);
        if (this.reportService.showOwnershipSalary() == 1) {
          this.router.navigateByUrl(`/report/${this.currentReport.ID}/salary/manager-salary`);
        } else if (this.reportService.showOwnershipSalary() == 2) {
          this.router.navigateByUrl(`/report/${this.currentReport.ID}/salary/replacement-salary`);
        } else {
          this.router.navigateByUrl(`/report/${this.currentReport.ID}/adjustments`);
        }
      } else {
        this.toastr.error("Please fill all required fields of all added locations !")
      }
    } else if (currentLocationIndex < this.locationList.length - 1) {
      this.selectLocation(this.locationList[currentLocationIndex + 1]);
    }
  }

  /**
   * @description function call at the time of footer button click, for switch route or location
   */
  switchBackLocation() {
    const currentLocationIndex = this.locationList.findIndex(loc => loc.ID == this.selectedLocation.ID);
    if (currentLocationIndex <= 0) {
      // this.router.navigateByUrl(`/report/${this.currentReport.ID}/income/future-year`);
      /// this.router.navigateByUrl(`/report/${this.currentReport.ID}/income`);
      this.router.navigateByUrl(`/report/${this.currentReport.ID}/future-projection`);
    } else if (currentLocationIndex > 0) {
      this.selectLocation(this.locationList[currentLocationIndex - 1]);
    }
  }

  /**
   * @description function of interface for validation
   * @returns form valid or not
   */
  isFormValid(): boolean {
    return this.checkRequiredFields() || this.currentReport?.isLocked;
  }

  /**
   * @description function of interface for skip functionality
   * @returns form can be skippable or not
   */
  canBeSkipped(): boolean {
    return false;
  }

  /**
   * @description report footer button click options
   * @param buttonOption which button clicked by user
   */
  footerButtonClick(buttonOption: number) {
    if (buttonOption == FooterButtonOption.NEXT_CLICK) {
      this.switchNextLocation();
    } else if (buttonOption == FooterButtonOption.BACK_CLICK) {
      this.switchBackLocation();
    }
  }

}
